import { NamedComplexEnum } from '../../utils/complexEnum/NamedComplexEnum'
import { CIMSModule, CIMSModuleItem } from '../CIMSModule'
import {
  AdminPageItem,
  CustomFields,
  NonUserEmails,
  ProjectSettings,
  Roles,
  Users,
} from './instances/admin'
import {
  CASDispositionTypes,
  CASNotifications,
  CASPageItem,
  CASQuickLinks,
  CASRoutingGroups,
  CASSubtypes,
  CASTracker,
  CASTypes,
} from './instances/cas'
import {
  ConcretePageItem,
  ConcreteTestSets,
  DocumentChecklists,
  ConcreteTestingLabs,
  ConcreteNotifications,
} from './instances/concrete'
import {
  DeveloperPageItem,
  Developers,
  DeveloperSnapshots,
  UserSync,
} from './instances/dev'
import {
  DSActions,
  DSDisciplines,
  DSLog,
  DSNotifications,
  DSOrganizations,
  DSPageItem,
  DSQuickLinks,
  DSTypes,
} from './instances/ds'
import {
  CSV,
  BatchReports,
  ExportsPageItem,
  Filenames,
  PDFDesignLayers,
  PDFReports,
  PhotoExports,
} from './instances/importsExports'
import {
  FDCApprovalGroups,
  FDCConcurrences,
  FDCDisciplines,
  FDCNotifications,
  FDCPageItem,
  FDCQuickLinks,
  FDCTracker,
} from './instances/fdc'
import { IFINotifications, IFIPageItem, IFITracker } from './instances/ifi'
import {
  ManagePayItems,
  PayItemsPageItem,
  PayItemsSummary,
} from './instances/payItems'
import {
  IssuePageItem,
  IssueDispositionTypes,
  IssueNotifications,
  IssueQuickLinks,
  IssueTracker,
  IssueTypes,
} from './instances/issues'
import {
  RFIPageItem,
  RFITracker,
  RFIOrganizations,
  RFIResponseDisciplines,
  RFIQuickLinks,
  RFINotifications,
} from './instances/rfi'
import {
  AsphaltMixDesigns,
  ConcreteMixDesigns,
  MaterialsPageItem,
} from './instances/materials'
import {
  EJLog,
  EJNotifications,
  EJPageItem,
  EJQuickLinks,
  EJTypes,
} from './instances/ej'

export type CIMSPageItem =
  | AdminPageItem
  | CASPageItem
  | ConcretePageItem
  | DSPageItem
  | ExportsPageItem
  | FDCPageItem
  | PayItemsPageItem
  | IFIPageItem
  | IssuePageItem
  | RFIPageItem
  | EJPageItem
  | DeveloperPageItem
  | MaterialsPageItem
type Name = CIMSPageItem['name']
type ID = CIMSPageItem['id']
class CIMSPageEnum extends NamedComplexEnum<
  'CIMSPage',
  CIMSPageItem,
  Name,
  ID
> {
  readonly typename = 'CIMSPage'
  readonly CustomFields = CustomFields
  readonly NonUserEmails = NonUserEmails
  readonly ProjectSettings = ProjectSettings
  readonly Roles = Roles
  readonly Users = Users
  readonly CASTracker = CASTracker
  readonly CASRoutingGroups = CASRoutingGroups
  readonly CASTypes = CASTypes
  readonly CASSubtypes = CASSubtypes
  readonly CASQuickLinks = CASQuickLinks
  readonly CASNotifications = CASNotifications
  readonly ConcreteTestSets = ConcreteTestSets
  readonly DocumentChecklists = DocumentChecklists
  readonly ConcreteTestingLabs = ConcreteTestingLabs
  readonly ConcreteNotifications = ConcreteNotifications
  readonly DSLog = DSLog
  readonly DSTypes = DSTypes
  readonly DSOrganizations = DSOrganizations
  readonly DSDisciplines = DSDisciplines
  readonly DSActions = DSActions
  readonly DSQuickLinks = DSQuickLinks
  readonly DSNotifications = DSNotifications
  readonly PDFReports = PDFReports
  readonly CSV = CSV
  readonly BatchReports = BatchReports
  readonly PDFDesignLayers = PDFDesignLayers
  readonly PhotoExports = PhotoExports
  readonly Filenames = Filenames
  readonly FDCTracker = FDCTracker
  readonly FDCConcurrences = FDCConcurrences
  readonly FDCApprovalGroups = FDCApprovalGroups
  readonly FDCDisciplines = FDCDisciplines
  readonly FDCQuickLinks = FDCQuickLinks
  readonly FDCNotifications = FDCNotifications
  readonly PayItemsSummary = PayItemsSummary
  readonly ManagePayItems = ManagePayItems
  readonly IFITracker = IFITracker
  readonly IFINotifications = IFINotifications
  readonly IssueDispositionTypes = IssueDispositionTypes
  readonly IssueNotifications = IssueNotifications
  readonly IssueQuickLinks = IssueQuickLinks
  readonly IssueTracker = IssueTracker
  readonly IssueTypes = IssueTypes
  readonly RFITracker = RFITracker
  readonly RFIOrganizations = RFIOrganizations
  readonly RFIResponseDisciplines = RFIResponseDisciplines
  readonly RFIQuickLinks = RFIQuickLinks
  readonly RFINotifications = RFINotifications
  readonly DeveloperSnapshots = DeveloperSnapshots
  readonly CASDispositionTypes = CASDispositionTypes
  readonly ConcreteMixDesigns = ConcreteMixDesigns
  readonly AsphaltMixDesigns = AsphaltMixDesigns
  readonly EJLog = EJLog
  readonly EJNotifications = EJNotifications
  readonly EJTypes = EJTypes
  readonly EJQuickLinks = EJQuickLinks
  readonly UserSync = UserSync
  readonly Developers = Developers
  get values() {
    return [
      this.UserSync,
      this.CustomFields,
      this.NonUserEmails,
      this.ProjectSettings,
      this.Roles,
      this.Users,
      this.NonUserEmails,
      this.CASTracker,
      this.CASRoutingGroups,
      this.CASTypes,
      this.CASSubtypes,
      this.CASQuickLinks,
      this.CASNotifications,
      this.ConcreteTestSets,
      this.DocumentChecklists,
      this.ConcreteTestingLabs,
      this.ConcreteNotifications,
      this.DSLog,
      this.DSTypes,
      this.DSOrganizations,
      this.DSDisciplines,
      this.DSActions,
      this.DSQuickLinks,
      this.DSNotifications,
      this.PDFReports,
      this.CSV,
      this.BatchReports,
      this.PDFDesignLayers,
      this.PhotoExports,
      this.Filenames,
      this.FDCTracker,
      this.FDCConcurrences,
      this.FDCApprovalGroups,
      this.FDCDisciplines,
      this.FDCQuickLinks,
      this.FDCNotifications,
      this.PayItemsSummary,
      this.ManagePayItems,
      this.IFITracker,
      this.IFINotifications,
      this.IssueDispositionTypes,
      this.IssueNotifications,
      this.IssueQuickLinks,
      this.IssueTracker,
      this.IssueTypes,
      this.RFITracker,
      this.RFIOrganizations,
      this.RFIResponseDisciplines,
      this.RFIQuickLinks,
      this.RFINotifications,
      this.DeveloperSnapshots,
      this.CASDispositionTypes,
      this.ConcreteMixDesigns,
      this.AsphaltMixDesigns,
      this.EJLog,
      this.EJNotifications,
      this.EJTypes,
      this.EJQuickLinks,
      this.Developers,
    ]
  }
  readonly projectId = ':projectId'
  readonly deepLink = ':deepLink'
  findByModule(arg: CIMSModuleItem['id'] | CIMSModuleItem) {
    const { id } = typeof arg === 'string' ? CIMSModule.fromIdOrFail(arg) : arg
    return this.filter(({ module }) => module.id === id)
  }
  get withDeprecatedPaths() {
    return this.filter(
      ({ deprecatedPathnames, module }) =>
        !!deprecatedPathnames.length || !!module.deprecatedPathnames.length
    )
  }
  fromPath(options: { page: string | undefined; module: string | undefined }) {
    const { page: pagePathname, module: modulePathname } = options
    return this.find(({ pathname, module, deprecatedPathnames }) => {
      if (modulePathname && module.deprecatedPathnames.includes(modulePathname))
        return (
          !!pagePathname &&
          (pagePathname === pathname ||
            deprecatedPathnames.includes(pagePathname))
        )
      else if (pagePathname && deprecatedPathnames.includes(pagePathname))
        return (
          !!modulePathname &&
          (modulePathname === module.pathname ||
            module.deprecatedPathnames.includes(modulePathname))
        )
      else
        return module.pathname === modulePathname && pagePathname === pathname
    })
  }
}

export const CIMSPage = new CIMSPageEnum()
